import './_image-carousel-block.scss';
import 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/util';

(function imageCarouselBlock() {
  if (document.getElementsByClassName('carousel-inner').length > 0) {
    class ImageCarouselBlock {
      public init() {
        this.imageLazyLoadFade();

        const sizingCarousels = document.getElementsByClassName('carousel-inner_sizing');
        Array.from(sizingCarousels).forEach((sizingCarousel) => {
          sizingCarousel.addEventListener('click', (e) => {
            const target = e.target as HTMLElement;
            const carousel = target.parentElement?.parentElement;
            if (carousel?.classList.contains('carousel--full-screen')) {
              this.closeFullscreen(carousel);
            } else if (carousel) {
              this.openFullscreen(carousel);
            }
          });
        });
      }

      private imageLazyLoadFade(): void {
        const images = document.querySelectorAll('.high-resolution-image') as NodeListOf<HTMLElement>;
        images.forEach((image) => {
          const img = image as HTMLImageElement;
          // If slow internet (3G) then image might already be loaded before script, so we also need to check if completed
          if (img.complete) {
            this.fadeOutLowResolutionImage(img);
          } else {
            img.onload = () => this.fadeOutLowResolutionImage(img);
          }
        });
      }

      private fadeOutLowResolutionImage(img: HTMLImageElement) {
        const image = img as HTMLImageElement;
        // Get low resolution image set opacity to zero in order "hide" and show the high resolution image
        const imageParentElement = image.parentElement?.parentElement;
        const lowResolutionImage = imageParentElement ? (imageParentElement.querySelector('.low-resolution-image') as HTMLElement) : null;
        if (lowResolutionImage) lowResolutionImage.classList.add('low-resolution-image__high-resolution-loaded');
      }

      private closeFullscreen(fullScreenCarousel: HTMLElement): void {
        fullScreenCarousel.classList.remove('carousel--full-screen');
        this.toggleImageSizes(fullScreenCarousel.querySelectorAll('.carousel-item') as NodeListOf<HTMLElement>);
        document.body.classList.remove('overflow-hidden');
        window.removeEventListener('keydown', this.handleKeyDown);
      }

      private openFullscreen(fullScreenCarousel: HTMLElement): void {
        fullScreenCarousel.classList.add('carousel--full-screen');
        this.toggleImageSizes(fullScreenCarousel.querySelectorAll('.carousel-item') as NodeListOf<HTMLElement>);
        document.body.classList.add('overflow-hidden');
        window.addEventListener('keydown', this.handleKeyDown);
      }

      private handleKeyDown = (e: KeyboardEvent): void => {
        const fullScreenCarousel = document.querySelector('.carousel--full-screen') as HTMLElement;
        if (e.key === 'Escape' && fullScreenCarousel) {
          this.closeFullscreen(fullScreenCarousel);
        }
      };

      // Toggle image sizes in carousel
      private toggleImageSizes(carouselItems: NodeListOf<HTMLElement>): void {
        carouselItems.forEach((carouselItem) => {
          const figureElementNormalWidth = carouselItem.querySelector('figure.normal-width') as HTMLElement;
          if (figureElementNormalWidth.style.display === 'block') figureElementNormalWidth.style.display = 'none';
          else figureElementNormalWidth.style.display = 'block';

          const figureElementFullWidth = carouselItem.querySelector('figure.full-width') as HTMLElement;
          if (figureElementFullWidth.style.display === 'none') figureElementFullWidth.style.display = 'block';
          else figureElementFullWidth.style.display = 'none';
        });
      }
    }
    const block = new ImageCarouselBlock();
    block.init();
  }
})();
